import React, { useEffect, useState } from 'react';
import { FaTimes, FaNetworkWired, FaInfoCircle, FaFilePdf } from 'react-icons/fa';
import NoPdfMessage from './NoPdfMessage';
import './SimpleDeviceModal.css';

const SimpleDeviceModal = ({ device, onClose }) => {
  const [showNoPdfMessage, setShowNoPdfMessage] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target.className === 'simple-modal-backdrop') {
      onClose();
    }
  };

  const handleViewPdf = () => {
    // Por padrão, dispositivos do catálogo não têm PDF, então mostra a mensagem
    setShowNoPdfMessage(true);
  };

  return (
    <div className="simple-modal-backdrop" onClick={handleBackdropClick}>
      <div className="simple-modal-content">
        <button className="simple-modal-close" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="simple-modal-header">
          <h2>{device.name}</h2>
          <div className="simple-modal-meta">
            <span className="meta-badge">{device.category}</span>
            <span className="meta-protocol">
              <FaNetworkWired /> {device.protocol}
            </span>
            <span className="meta-port">Porta: {device.port}</span>
          </div>
        </div>

        <div className="simple-modal-body">
          <div className="info-card">
            <FaInfoCircle className="info-icon" />
            <div>
              <h3>Informações do Dispositivo</h3>
              <ul>
                <li><strong>Nome:</strong> {device.name}</li>
                <li><strong>Protocolo:</strong> {device.protocol}</li>
                <li><strong>Porta TCP:</strong> {device.port}</li>
                <li><strong>Categoria:</strong> {device.category}</li>
              </ul>
            </div>
          </div>

          <div className="config-info">
            <h3>Configuração Básica no Traccar</h3>
            <div className="config-code">
              <p><strong>1.</strong> Habilite o protocolo <code>{device.protocol}</code> no traccar.xml</p>
              <pre>{`<entry key='${device.protocol}.port'>${device.port}</entry>`}</pre>
              
              <p><strong>2.</strong> Configure o dispositivo para enviar dados ao servidor</p>
              <pre>{`IP: seu-servidor.com
Porta: ${device.port}
Protocolo: ${device.protocol.toUpperCase()}`}</pre>
            </div>
          </div>

          <div className="documentation-link">
            <p>
              Para documentação completa, visite:{' '}
              <a 
                href="https://www.traccar.org/devices/" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Traccar - Dispositivos Suportados
              </a>
            </p>
          </div>
        </div>

        <div className="simple-modal-footer">
          <button onClick={handleViewPdf} className="btn-pdf-simple">
            <FaFilePdf /> Ver Manual
          </button>
          <button onClick={onClose} className="btn-close-modal">
            Fechar
          </button>
          <button 
            onClick={() => {
              onClose();
              setTimeout(() => {
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }, 300);
            }}
            className="btn-quote-modal"
          >
            Solicitar Orçamento
          </button>
        </div>
      </div>

      {/* Mensagem sem PDF */}
      {showNoPdfMessage && (
        <NoPdfMessage 
          deviceName={device.name}
          onClose={() => setShowNoPdfMessage(false)}
        />
      )}
    </div>
  );
};

export default SimpleDeviceModal;

